interface IDownloadFileOptions {
  file?: Blob;
  fileName: string;
  textResponse?: string;
  url?: string;
}

export const downloadFile = (options: IDownloadFileOptions): void => {
  let url = options.url ?? '';

  if (options.textResponse) {
    url = window.URL.createObjectURL(new Blob([options.textResponse], { type: 'application/octet-stream' }));
  }

  if (options.file) {
    url = window.URL.createObjectURL(options.file);
  }

  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  a.download = options.fileName;

  document.body.appendChild(a);
  a.click();
  a.remove();

  setTimeout(() => URL.revokeObjectURL(url), 200);
};
